import { 
    apiBizGetInsertCaseList,
    apiBizInsertHouse ,
    apiBizInsertHouseImage,
    apiBizInsertHouseNoReview,
    apiBizBatchHouse,
    apiBizPublishHouse
} from "@/apis/api.js"; 
import { 
    uploadVideo,
    uploadHouseAttorney
} from "@/apis/company/houseMgt.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    get_house_default: 'bizAddHouse/get_house_default',
    set_house_list: 'bizAddHouse/set_house_list',
    set_image_files: 'bizAddHouse/set_image_files',
    set_video: 'bizAddHouse/set_video',
    set_landlord_auth: 'bizAddHouse/set_landlord_auth',
    set_cover: 'bizAddHouse/set_cover',
    set_save_fail: 'bizAddHouse/set_save_fail',
    set_save_success: 'bizAddHouse/set_save_success',
    set_contract_version_mode: 'bizAddHouse/set_contract_version_mode',
}

// count state 必須是 Object
const state = {
    houseDefaultList: [],
    houseList: [],
    imageFiles: [],
    video: null,
    landlordAuth: null,
    contractVersionMode: null,
    cover: [],
    error: {
        state: false,
        msg: '儲存失敗，請再試一次'
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_RULES: (state) => {
        return state.houseDefaultList.rules
    },
    GET_BIZ_EQUIPS: (state) => {
        return state.houseDefaultList.equips
    },
    GET_BIZ_RENT_INCLUDE: (state) => {
        return state.houseDefaultList.rentInclude
    },
    GET_BIZ_FEATURES: (state) => {
        return state.houseDefaultList.features
    },
    GET_BIZ_BUILDING_TYPE: (state) => {
        return state.houseDefaultList.buildingTypeList
    },
    GET_BIZ_HOUSE_TYPE: (state) => {
        return state.houseDefaultList.houseTypeList
    },
    GET_BIZ_SPECIAL_TYPE: (state) => {
        return state.houseDefaultList.specialTypeList
    },
    GET_BIZ_HOUSE_POLICY: (state) => {
        return state.houseDefaultList.caseHousePolicyDto.policySettingUseDtoList
    },
    GET_BIZ_DESPOSIT_POLICY: (state) => {
        return state.houseDefaultList.caseDepositPolicyDto.policySettingUseDtoList
    },
    GET_BIZ_CONTRACT_VERSION_MODE: (state) => {
        return state.contractVersionMode
    },
    GET_BIZ_SAVE_STATE: (state) => {
        return state.error
    },
    GET_BIZ_HOUSE_HAS_IMAGE: (state) => {
        if(state.imageFiles.length > 0){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_HOUSE_HAS_COVER: (state) => {
        if(state.cover.length > 0){
            return true
        }else{
            return false
        }
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizHouseDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            apiBizGetInsertCaseList()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result
                    commit(types.get_house_default, value);
                    resolve()
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizHouseList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_list, data);
            resolve()
        })
    },
    setBizImageFiles ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_image_files, data);
            resolve()
        })
    },
    setBizCover ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_cover, data);
            resolve()
        })
    },
    saveBizHouse ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            // dispatch('saveImage')
            apiBizInsertHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        dispatch('saveBizVideo', res.data.result.houseCid )
                        .then( () => {
                        })
                    }
                    if(state.landlordAuth && state.landlordAuth.length > 0){
                        dispatch('saveBizLandlordAuth', res.data.result.houseCid )
                        .then( () => {
                        })
                    }
                    if(state.imageFiles.length > 0){
                        dispatch('saveBizImage', res.data.result.houseCid ).
                        then( () => {
                            dispatch('setBizImageFiles', [])
                            dispatch('setBizCover', [])
                            dispatch('setBizPublish', {houseCid: res.data.result.houseCid, status: 'REVEAL'})
                            resolve()
                        })
                    }else{
                        resolve()
                    }
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    reject()
                }
            })
            .catch(err => {
                reject(err)
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
            })
        })
    },
    saveBizHouseNoReview ( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiBizInsertHouseNoReview(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        dispatch('saveBizVideo', res.data.result.houseCid )
                        .then( () => {
                        })
                    }
                    if(state.landlordAuth && state.landlordAuth.length > 0){
                        dispatch('saveBizLandlordAuth', res.data.result.houseCid )
                        .then( () => {
                        })
                    }
                    if(state.imageFiles.length > 0  || state.cover.length > 0){
                        dispatch('saveBizImage', res.data.result.houseCid ).
                        then( () => {
                            dispatch('setBizImageFiles', [])
                            dispatch('setCover', [])
                            resolve()
                        })
                    }else{
                        resolve()
                    }
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizImage ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let houseCid = data,
                cover = state.cover.length?state.cover[0].file:null

            formData.append('houseCid', houseCid);
            formData.append('headImage', cover);
            state.imageFiles.map( (image, index) => {
                formData.append('bodyImageArray', image.file);
            })
            apiBizBatchHouse(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizVideo ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let houseCid = data,
            houseFilm = state.video.length?state.video[0].file:null

            formData.append('houseCid', houseCid);
            formData.append('houseFilm', houseFilm);
            uploadVideo(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizLandlordAuth ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let houseCid = data,
            houseAttorney = state.landlordAuth.length?state.landlordAuth[0].file:null

            formData.append('houseCid', houseCid);
            formData.append('houseAttorney', houseAttorney);
            console.log('houseCid', houseCid)
            console.log('houseAttorney', houseAttorney)
            uploadHouseAttorney(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizPublish( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            // let obj = {
            //     "houseCid": state.houseCid,
            //     "status": data
            // }
            apiBizPublishHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(data)
                    
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})

                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizVideo( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_video, data);
        })
    },
    setBizLandlordAuth( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_landlord_auth, data);
        })
    },
    setBizContractVersionMode( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_version_mode, data);
        })
    },
}

// mutations
const mutations = {
    [types.get_house_default](state, data){
        state.houseDefaultList = data
    },
    [types.set_house_list](state, data){
        state.houseList = data
    },
    [types.set_image_files](state, data){
        state.imageFiles = data
    },
    [types.set_video](state, data){
        state.video = data
    },
    [types.set_landlord_auth](state, data){
        state.landlordAuth = data
    },
    [types.set_cover](state, data){
        state.cover = data
    },
    [types.set_save_fail](state, data){
        state.error.state = true
        state.error.msg = data
    },
    [types.set_save_success](state){
        state.error.state = false
        state.error.msg = ''
    },
    [types.set_contract_version_mode](state, data){
        state.contractVersionMode = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseMgt/addHouse.js